import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSingleInsightBorderNegative = (props) => /* @__PURE__ */ _jsx("svg", {
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M3.96778 32.5431C3.07406 32.1379 2.5 31.2474 2.5 30.2661L2.5 6.99999C2.5 6.17157 3.17158 5.5 4 5.5L30 5.5C30.8284 5.5 31.5 6.17157 31.5 7L31.5 30.2661C31.5 31.2474 30.9259 32.1379 30.0322 32.5431L17.6193 38.1703C17.2257 38.3487 16.7743 38.3487 16.3807 38.1703L3.96778 32.5431Z" })
});
export default SvgSingleInsightBorderNegative;
